export enum Logo {
    title = 'DM',
}

export enum Buttons {
    create = 'Objavite resurs',
    createPublication = 'Objavite oglas',
    aboutMe = 'O meni',
    managers = 'Menadžeri',
    signIn = 'Prijava',
    signOut = 'Odjava',
    register = 'Registracija',
    news = 'VESTI',
    subscriptions = 'PRETPLATE',
    contact = 'KONTAKT',
}

export enum CodebooksTitle {
    title = 'Šifarnici',
}

export enum CodebooksLabels {
    users = 'Korisnici',
    roles = 'Role',
}

export enum UserProfile { 
    profile = 'Moj profil',
    logout = 'Odjava',
    changePassword = 'Promena lozinke',     
}